import React from 'react'
import { Field } from 'redux-form'
import renderSelect from '../fields/renderSelect'
import renderField from '../fields/renderField'
import RenderDateRangePicker from '../fields/renderDateRangePicker'
import i18n from '../../translations/i18n';

const numberArray = [...Array(31).keys()].slice(1)

let Interpreting = props => {
	let lng = props.lng;
	let locale = (lng==="fr" ? "fr" : "en-gb")
	return (
			<div>
			<div className="form-section">
			<div className="subtitle title title-border title-border text-left">
				<h6>{i18n.t('interpreting.title', {lng})}</h6>
			</div>
			<div className="row">
				<div className="col-12 text-center form-input">
					<span className="small">{i18n.t('interpreting.dates_title', {lng})}</span>
					<RenderDateRangePicker 
						startLabel={i18n.t('interpreting.desired_start_date', {lng})}
						endLabel={i18n.t('interpreting.desired_end_date', {lng})}
						localeLang={locale}
					/>
				</div>
			</div>
			<div className="row">
				<div className="col-12 form-input">
					<Field
						name="interpretingDuration"
						component={renderSelect}
						label={i18n.t('interpreting.durations', {lng})}
						options={props.durations}
						placeholder={i18n.t('app.please_select', {lng})}
					/>
				</div>
			</div>
			<div className="row">
				<div className="col-12 form-input">
					<Field
						name="interpretingLocation"
						component={renderField}
						label={i18n.t('interpreting.location', {lng})}
						placeholder={i18n.t('interpreting.location_placeholder', {lng})}
					/>
				</div>
			</div>
			<div className="row">
				<div className="col-6 form-input">
					<Field
						name="sourceLanguage"
						component={renderSelect}
						label={i18n.t('interpreting.source_language', {lng})}
						placeholder={i18n.t('interpreting.source_language_placeholder', {lng})}
						options={props.fromLang}
					/>
				</div>
				<div className="col-6 form-input">
					<Field
						name="targetLanguage"
						component={renderSelect}
						label={i18n.t('interpreting.target_language', {lng})}
						placeholder={i18n.t('interpreting.target_language_placeholder', {lng})}
						options={props.toLang}
					/>
				</div>
			</div>
			<div className="row">
				<div className="col-6 form-input">
					<Field
						name="audienceNumber"
						component={renderSelect}
						label={i18n.t('interpreting.audience', {lng})}
						options={numberArray}
						placeholder={i18n.t('app.please_select', {lng})}
					/>
				</div>
				<div className="col-6 form-input">
					<Field
						name="interpretorsNumber"
						component={renderSelect}
						label={i18n.t('interpreting.interpretors', {lng})}
						options={numberArray}
						placeholder={i18n.t('app.please_select', {lng})}
					/>
				</div>
			</div>
			<div className="row">
				<div className="col-6 form-input">
					<Field
						name="interpretingPurpose"
						component={renderSelect}
						label={i18n.t('interpreting.purpose', {lng})}
						options={props.interpretingPurposes}
						placeholder={i18n.t('app.please_select', {lng})}
					/>
				</div>
				<div className="col-6 form-input">
					<Field
						name="interpretingType"
						component={renderSelect}
						label={i18n.t('interpreting.type', {lng})}
						options={props.interpretingTypes}
						placeholder={i18n.t('app.please_select', {lng})}
					/>
				</div>
			</div>
			</div>
		</div>
	)
  }


  export default Interpreting


// WEBPACK FOOTER //
// ./src/components/interpreting/interpreting.js